import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import db from "./Firebase";
import TopPanel from "./TopPanel";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { extendMoment } from "moment-range";
import Select from "react-select";
import { useCookies } from "react-cookie";
import Footer from "./Footer";
import ExistingTickets from "./TicketsDialogs/ExistingTickets";
import GlobalContext from "./context/GlobalContext";
import {
  addDoc,
  collection,
  onSnapshot,
  query,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import "react-datepicker/dist/react-datepicker.css";

function Tickets() {
  const navigate = useNavigate();
  const { permissible_roles } = useContext(GlobalContext);
  const { username } = useContext(GlobalContext).state_user;
  
  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedIn") === "true";
    if (loggedIn) {
      // navigate("/");
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const [cookies] = useCookies(["permissions"]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const moment = extendMoment(Moment);

  const [activePopUp, setActivePopUp] = useState("");
  const ticketActionOptions = ["Open", "In Progress", "Resolved"];
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const [filteredData, setFilteredData] = useState([]);

  // --- NEW STATE VARIABLES FOR NOTES ---
  const [noteText, setNoteText] = useState("");
  const [selectedTicketRef, setSelectedTicketRef] = useState(null);

  // Anushka's Pagination Logic
  const [currentPage, setCurrentPage] = useState(1); 
  const recordsPerPage = 5;
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // ek time me kitne page buttons dikhaane
  const visiblePageCount = 2;

  // abhi window ka start page rakhte hain
  const [startPage, setStartPage] = useState(1);

  // window ka end page
  const endPage = Math.min(startPage + visiblePageCount - 1, totalPages);

  // window ke page numbers
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // data slice
  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  const currentRecords = filteredData.slice(startIndex, endIndex);

  // next page logic
  const handleNext = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      if (newPage > endPage) {
        setStartPage(startPage + visiblePageCount);
      }
    }
  };

  // prev page logic
  const handlePrev = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      if (newPage < startPage) {
        setStartPage(startPage - visiblePageCount);
      }
    }
  };

  // load more → next window pe jump karo
  const handleLoadMore = () => {
    const nextStart = startPage + visiblePageCount;
    if (nextStart <= totalPages) {
      setStartPage(nextStart);
      setCurrentPage(nextStart); // jump first page of new window
    }
  };

  useEffect(() => {
    const unsubscribe = listenToTickets();
    return () => unsubscribe();
  }, []);

  const listenToTickets = () => {
    const ticketOrder = {
      Open: 1,
      ["In Progress"]: 2,
      Resolved: 3,
    };
    const q = query(collection(db, "tickets"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const fineData = snapshot.docs.map((doc) => ({
          ref: doc.ref,
          id: doc.id,
          data: doc.data(),
        }));
        const sortData = fineData.sort(
          (a, b) => ticketOrder[a.data.status] - ticketOrder[b.data.status]
        );
        setData(sortData);
      } else {
        setData([]);
      }
    });

    return unsubscribe;
  };

  const AddTicketActivity = async (ticketData, action) => {
    try {
      const customer_activity_ref = collection(db, "customer_activities");
      const activityData = {
        customer_name: ticketData.customer_name,
        customer_id: ticketData.customer_id,
        customer_phone: ticketData.customer_phone,
        object: "Ticket Action",
        action: "status update",
        description: `Ticket ${ticketData.ticket_id} was ${action} by ${username}`,
        platform: "crm",
        user: username,
        created_date: new Date(Date.now()),
        date: new Date(Date.now()),
      };
      await addDoc(customer_activity_ref, activityData);
    } catch (err) {
      console.log(err.message);
    }
  };

  const HandleTicketAction = async (ticketRef, action, ticketData) => {
    try {
      await updateDoc(ticketRef, { status: action });
      await AddTicketActivity(ticketData, action);
    } catch (err) {
      console.error(err.message);
    }
  };

  const togglePopup = (value) => {
    setActivePopUp(value);
  };

  const OpenAttachment = (link) => {
    window.open(link, "_blank");
  };

  // --- NEW FUNCTIONS FOR NOTES ---
  const handleOpenNotePopup = (ticketRef, currentNote) => {
    setSelectedTicketRef(ticketRef);
    setNoteText(currentNote || "");
    setActivePopUp("addNote");
  };

  const handleSaveNote = async () => {
    if (!selectedTicketRef) return;
    try {
      setLoading(true);
      await updateDoc(selectedTicketRef, { notes: noteText });
      
      setActivePopUp("");
      setNoteText("");
      setLoading(false);
      
      Swal.fire({
        icon: 'success',
        title: 'Note updated successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Failed to update note',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  const generateCsvheader = [
    { label: "Ticket ID", key: "ticket_id" },
    { label: "Customer Name", key: "customer_name" },
    { label: "Customer Phone", key: "customer_phone" },
    { label: "Category", key: "category" },
    { label: "Sub Category", key: "sub_category" },
    { label: "Subject", key: "subject" },
    { label: "Description", key: "description" },
    { label: "Order date", key: "order_date" },
    { label: "Attachment", key: "attachment" },
    { label: "Status", key: "status" },
    { label: "Notes", key: "notes"} // Added Notes to CSV Header
  ];

  const csvData = filteredData.map((item) => ({
    ticket_id: item.data.ticket_id,
    customer_name: item.data.customer_name,
    customer_phone: item.data.customer_phone,
    category: item.data.category,
    sub_category: item.data.sub_category,
    subject: item.data.subject,
    description: item.data.description,
    order_date: item.data.order_date
      ? new Timestamp(
        item.data.order_date?.seconds,
        item.data.order_date?.nanoseconds
      )
        .toDate()
        .toLocaleDateString()
      : "Not Selected",
    attachment: item.data.attachment
      ? item.data.attachment
      : "No Attachment",
    status: item.data.status,
    notes: item.data.notes || ""
  }));

  useEffect(() => {
    if (!fromDate && !toDate) {
      setFilteredData(data);
      return;
    }

    const start = fromDate
      ? moment(fromDate).startOf("day").valueOf()
      : moment("2000-01-01").startOf("day").valueOf();

    const end = toDate
      ? moment(toDate).endOf("day").valueOf()
      : Number.MAX_SAFE_INTEGER; 

    const filtered = data.filter((item) => {
      if (
        item.data?.created_date &&
        typeof item.data.created_date.toDate === "function"
      ) {
        const createdMs = item.data.created_date.toDate().getTime();
        return createdMs >= start && createdMs <= end;
      }
      return false;
    });

    setFilteredData(filtered);
  }, [fromDate, toDate, data]);

  return (
    <>
      <div className="">
        {activePopUp === "existingTickets" && (
          <div className="popup">
            <div className="popup-inner">
              <div className="close_btn_position">
                <button className="close_btn" onClick={() => togglePopup("")}>
                  X
                </button>
              </div>
              <ExistingTickets
                setActivePopUp={setActivePopUp}
                permissible_roles={permissible_roles}
              />
            </div>
          </div>
        )}

        {/* --- ADD NOTE POPUP --- */}
       {/* --- ADD NOTE POPUP --- */}
        {activePopUp === "addNote" && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px 25px",
                borderRadius: "8px",
                width: "90%",
                maxWidth: "500px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <h4 style={{ margin: 0 }}>Add / Edit Note</h4>
                <button
                  onClick={() => togglePopup("")}
                  style={{
                    backgroundColor: "#ff4d4d",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  title="Close"
                >
                  X
                </button>
              </div>

              {/* Textarea */}
              <textarea
                className="form-control"
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
                placeholder="Type your notes here..."
                style={{
                  width: "100%",
                  minHeight: "120px",
                  padding: "10px",
                  resize: "vertical",
                  borderRadius: "5px",
                  border: "1px solid #ced4da",
                }}
              ></textarea>

              {/* Action Button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "15px",
                }}
              >
                <button
                  className="btn btn-success"
                  onClick={handleSaveNote}
                  style={{ padding: "8px 20px" }}
                >
                  Save Note
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="">
            <img
              style={{
                height: "6rem",
              }}
              src="images/loader.gif"
              alt=""
            ></img>
          </div>
        </div>
      )}
      
      <div className="container-scroller">
        <TopPanel />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h4 className="card-title">Tickets</h4>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <DatePicker
                          selected={fromDate}
                          onChange={(date) => setFromDate(date)}
                          placeholderText="From Date"
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                        />
                        <DatePicker
                          selected={toDate}
                          onChange={(date) => setToDate(date)}
                          placeholderText="To Date"
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                        />
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={() => {
                            setFromDate(null);
                            setToDate(null);
                          }}
                        >
                          Clear
                        </button>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-success btn-rounded btn-sm"
                            onClick={() => togglePopup("existingTickets")}
                          >
                            + Tickets Category
                          </button>
                        </div>
                        <div>
                          <CSVLink
                            data={csvData}
                            headers={generateCsvheader}
                            filename={"tickets.csv"}
                            className="btn btn-primary btn-rounded btn-sm"
                          >
                            Download CSV
                          </CSVLink>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Ticket ID</th>
                            <th>Customer Name</th>
                            <th>Customer Phone</th>
                            <th>Category</th>
                            <th>Sub-Category</th>
                            <th>Subject</th>
                            <th
                              style={{
                                maxWidth: "450px",
                              }}
                            >
                              Description
                            </th>
                            <th>Order date</th>
                            <th>Preferred Mode</th>
                            <th>Attachment</th>
                            <th>Notes</th> {/* NEW COLUMN HEADER */}
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRecords.length ? (
                            currentRecords.map(({ ref, id, data }, index) => {
                              return (
                                <tr key={id}>
                                  <td>{data.ticket_id || "-"}</td>
                                  <td>{data.customer_name || "-"}</td>
                                  <td>{data.customer_phone || "-"}</td>
                                  <td>{data.category || "-"}</td>
                                  <td>{data.sub_category || "-"}</td>

                                  <td
                                    style={{
                                      maxWidth: "150px",
                                      wordBreak: "keep-all",
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {data.subject || "-"}
                                  </td>
                                  <td
                                    style={{
                                      maxWidth: "300px",
                                      wordBreak: "keep-all",
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {data.description || "-"}
                                  </td>
                                  <td>
                                    {data.order_date
                                      ? new Timestamp(
                                        data.order_date?.seconds,
                                        data.order_date?.nanoseconds
                                      )
                                        .toDate()
                                        .toLocaleDateString()
                                      : "Not Selected"}
                                  </td>
                                  <td>{data.preferred_mode || "-"}</td>
                                  <td>
                                    {data.attachment.length > 0 ? (
                                      data.attachment.map((link, idx) => (
                                        <img
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            display: "inline",
                                            cursor: "pointer",
                                          }}
                                          src={link}
                                          key={idx}
                                          alt="issue image"
                                          onClick={() => OpenAttachment(link)}
                                        />
                                      ))
                                    ) : (
                                      <p>No Attachments</p>
                                    )}
                                  </td>

                                  {/* --- NEW NOTES CELL --- */}
                                  <td
                                    style={{
                                      maxWidth: "200px",
                                      wordBreak: "keep-all",
                                      overflowWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {data.notes || "-"}
                                  </td>

                                  <td>
                                    <span
                                      className=""
                                      style={{
                                        borderTopRightRadius: "10px",
                                        borderTopLeftRadius: "10px",
                                        borderBottomRightRadius: "10px",
                                        borderBottomLeftRadius: "10px",
                                        padding: "5px 10px",
                                        backgroundColor: `${data.status === "Resolved"
                                          ? "#83bf91"
                                          : data.status === "In Progress"
                                            ? "#EEF25E"
                                            : "#C6CACE"
                                          }`,
                                        color: "white",
                                      }}
                                    >
                                      {data.status}
                                    </span>
                                  </td>
                                  <td>
                                    {data.status === "Resolved" ? (
                                      "-"
                                    ) : (
                                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <select
                                          value={data.status}
                                          style={{
                                            borderTopRightRadius: "10px",
                                            borderTopLeftRadius: "10px",
                                            borderBottomRightRadius: "10px",
                                            borderBottomLeftRadius: "10px",
                                          }}
                                          onChange={(e) => {
                                            HandleTicketAction(
                                              ref,
                                              e.target.value,
                                              data
                                            );
                                          }}
                                        >
                                          {ticketActionOptions.map((e) => {
                                            return (
                                              <option value={e} key={e}>
                                                {e}
                                              </option>
                                            );
                                          })}
                                        </select>
                                        
                                        {/* --- EDIT BUTTON (ONLY IF STATUS IS OPEN) --- */}
                                        {data.status === "Open" && (
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            style={{ padding: "4px 8px", borderRadius: "5px" }}
                                            onClick={() => handleOpenNotePopup(ref, data.notes)}
                                            title="Add Note"
                                          >
                                            Add Notes
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="13" className="text-center">
                                No Active Ticket Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div
                      className="pagination"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "12px",
                        width: "80vw",
                        backgroundColor: "#f9f9f9",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        disabled={currentPage === 1}
                        onClick={handlePrev}
                        style={{
                          padding: "6px 14px",
                          fontSize: "14px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          backgroundColor: currentPage === 1 ? "#e5e7eb" : "#2563eb",
                          color: currentPage === 1 ? "#9ca3af" : "#fff",
                          cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        Prev
                      </button>

                      {pageNumbers.map((pageNum) => {
                        const isActive = currentPage === pageNum;
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setCurrentPage(pageNum)}
                            style={{
                              padding: "6px 14px",
                              fontSize: "14px",
                              borderRadius: "6px",
                              border: isActive ? "1px solid #2563eb" : "1px solid #ccc",
                              backgroundColor: isActive ? "#2563eb" : "#fff",
                              color: isActive ? "#fff" : "#374151",
                              cursor: "pointer",
                            }}
                          >
                            {pageNum}
                          </button>
                        );
                      })}

                      <button
                        disabled={currentPage === totalPages}
                        onClick={handleNext}
                        style={{
                          padding: "6px 14px",
                          fontSize: "14px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                          backgroundColor: currentPage === totalPages ? "#e5e7eb" : "#2563eb",
                          color: currentPage === totalPages ? "#9ca3af" : "#fff",
                          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                        }}
                      >
                        Next
                      </button>

                      {visiblePageCount < totalPages && (
                        <button
                          onClick={handleLoadMore}
                          style={{
                            padding: "6px 16px",
                            fontSize: "14px",
                            borderRadius: "6px",
                            border: "none",
                            backgroundColor: "#10b981",
                            color: "#fff",
                            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                          }}
                        >
                          Load More
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Tickets;